export default __webpack_public_path__ + "static/media/132.e59f0032.jpg";